export default "__VITE_ASSET__49963e00__"